import React from 'react';
import nursePortraitHospital from '../../assets/images/nurse-portrait-hospital.png';
import providersGroup from '../../assets/images/providers-group.png';
import icon2 from '../../assets/icons/icon-2.svg';

const TestimonialsSection: React.FC = () => {
  return (
    <div
      className="relative w-full bg-white py-12 md:py-20"
      data-name="Testimonials Section"
      id="node-12_9881"
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 lg:px-20">
        <div
          className="font-['Ovo',_serif] text-[#1f1f1f] text-[28px] md:text-[40px] lg:text-[48px] text-center uppercase mb-4 md:mb-6"
          id="node-12_9882"
        >
          <p className="block leading-[normal]">What Providers Are Saying</p>
        </div>
        <div
          className="font-['Ovo',_serif] font-normal text-[#1f1f1f] text-[18px] md:text-[20px] lg:text-[24px] text-center mb-8 md:mb-16 max-w-[673px] mx-auto"
          id="node-12_9883"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          <p className="block leading-[normal]">
            Real feedback from real professionals growing with CLOUT.
          </p>
        </div>
        <div className="flex flex-col xl:flex-row justify-center gap-6 md:gap-8">
          <div
            className="bg-[rgba(248,246,242,0.5)] backdrop-blur-sm flex flex-col md:flex-row h-auto md:h-[350px] items-stretch w-full xl:w-[600px] rounded-lg overflow-hidden shadow-md"
            data-name="Testimonial Content"
            id="node-12_9884"
          >
            <div className="relative w-full md:w-[240px] h-[250px] md:h-auto bg-[#f8f6f2] flex items-end justify-center overflow-hidden">
              <img
                src={nursePortraitHospital}
                alt="Dr Emma Hills - Dermatologist sharing her experience with CLOUT"
                className="h-full md:h-[300px] w-auto object-contain object-bottom transition-transform hover:scale-105"
                loading="lazy"
                style={{
                  maxWidth: 'none',
                  transform: 'translateX(-20px)',
                }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                }}
              />
            </div>
            <div className="flex-1 flex items-center p-6 md:px-8">
              <div className="flex flex-col gap-2 md:gap-3">
                <div>
                  <div
                    className="font-['Ovo',_serif] text-[24px] md:text-[32px] uppercase text-[#1f1f1f] leading-tight"
                    id="node-12_9891"
                  >
                    Dr Emma Hills
                  </div>
                  <div
                    className="font-['Ovo',_serif] font-normal text-[12px] text-[#1f1f1f]"
                    id="node-12_9892"
                    style={{ fontVariationSettings: "'wdth' 100" }}
                  >
                    Dermatologist
                  </div>
                </div>
                <div className="flex gap-1">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="size-4">
                      <img src={icon2} alt="star" className="w-full h-full" />
                    </div>
                  ))}
                </div>
                <div
                  className="font-['Ovo',_serif] font-normal text-[#1f1f1f] text-[14px] md:text-[16px] lg:text-[18px] leading-normal"
                  id="node-12_9900"
                  style={{ fontVariationSettings: "'wdth' 100" }}
                >
                  CLOUT has elevated my professional standing. I've not only gained visibility but
                  also meaningful recognition from peers I deeply admire.
                </div>
              </div>
            </div>
          </div>

          <div
            className="bg-[rgba(248,246,242,0.5)] backdrop-blur-sm flex flex-col md:flex-row h-auto md:h-[350px] items-stretch w-full xl:w-[600px] rounded-lg overflow-hidden shadow-md"
            data-name="Testimonial Content"
            id="node-12_9901"
          >
            <div className="relative w-full md:w-[240px] h-[250px] md:h-auto bg-[#f8f6f2] flex items-end justify-center overflow-hidden">
              <img
                src={providersGroup}
                alt="Dr. Lianne Cross - Cosmetic Surgeon highlighting CLOUT's impact on her practice"
                className="h-full md:h-[320px] w-auto object-contain object-bottom transition-transform hover:scale-105"
                loading="lazy"
                style={{
                  maxWidth: 'none',
                }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                }}
              />
            </div>
            <div className="flex-1 flex items-center p-6 md:px-8">
              <div className="flex flex-col gap-2 md:gap-3">
                <div>
                  <div
                    className="font-['Ovo',_serif] text-[24px] md:text-[32px] uppercase text-[#1f1f1f] leading-tight"
                    id="node-12_9909"
                  >
                    Dr. Lianne Cross
                  </div>
                  <div
                    className="font-['Ovo',_serif] font-normal text-[12px] text-[#1f1f1f]"
                    id="node-12_9910"
                    style={{ fontVariationSettings: "'wdth' 100" }}
                  >
                    Cosmetic Surgeon
                  </div>
                </div>
                <div className="flex gap-1">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="size-4">
                      <img src={icon2} alt="star" className="w-full h-full" />
                    </div>
                  ))}
                </div>
                <div
                  className="font-['Ovo',_serif] font-normal text-[#1f1f1f] text-[14px] md:text-[16px] lg:text-[18px] leading-normal"
                  id="node-12_9918"
                  style={{ fontVariationSettings: "'wdth' 100" }}
                >
                  The endorsement system is a game-changer. It's built trust among patients and
                  providers alike — and boosted my practice's credibility online
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;
